.panel {
  width: 100%;
  box-sizing: border-box;
  padding: var(--gac-space-sm) var(--gac-space-md);
  border-radius: var(--gac-radius-md);
  background: var(--gac-surface-raised);
  border: 1px solid var(--gac-line-border);
}

.error {
  background: var(--gac-surface-raised);
  border-color: var(--gac-status-danger);
}

.head {
  display: flex;
  align-items: center;
  gap: var(--gac-space-xs);
}

/* The spinner is the only motion on the panel: one thing moving says "working", several say
   "broken". Reduced-motion visitors get a still ring rather than nothing, so the phase still
   reads as in-progress. */
.spinner {
  width: 16px;
  height: 16px;
  flex: none;
  border-radius: var(--gac-radius-pill);
  border: 2px solid var(--gac-line-border);
  border-top-color: var(--gac-accent);
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation: none;
  }
}

.link {
  color: var(--gac-accent);
  text-decoration: none;
  word-break: break-all;
}

.link:hover {
  text-decoration: underline;
}

.retry {
  align-self: flex-start;
  margin-top: var(--gac-space-xs);
}
